$.atsjs = function(){

};

$.atsjs.prototype._dataTableDom = function(){
  return "<'row'<'col-md-12'f>>" +
         "<'row'<'col-md-12'<'table-responsive'tr>>>" +
         "<'row'<'col-md-2'l><'col-md-5 info-paginator'i><'col-md-5 text-right'p>>";
};

$.atsjs.prototype._dataTableDomSemTableResponsive = function(){
  return "<'row'<'col-md-12'f>>" +
         "<'row'<'col-md-12'<tr>>>" +
         "<'row'<'col-md-2'l><'col-md-5 info-paginator'i><'col-md-5 text-right'p>>";
};

$.atsjs.prototype._dataTableLanguage = function(placeholderPesquisar){
return {
        "search": "<div class=\"filter-search\">"+
                  "<label class=\"search-label\">Pesquisar</label>"+
                  "<div class=\"input-group\">_INPUT_<div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div></div>"+
                  "<div>",
        "searchPlaceholder": placeholderPesquisar,
        "emptyTable":   "Sem dados disponíveis na tabela",
        "info":         "Mostrando _START_ de _END_ de _TOTAL_ registros",
        "infoEmpty":    "Mostrando de 0 até 0 de 0 registros",
        "infoFiltered": "",
        "infoPostFix":  "",
        "thousands":    ",",
        "lengthMenu":   "Mostrar _MENU_",
        "zeroRecords":  "Não foram encontrados resultados",
        "paginate": {
            "first":    "Primeiro",
            "last":     "Último",
            "next":     "<span class=\"glyphicon glyphicon glyphicon-chevron-right\"><span/>",
            "previous": "<span class=\"glyphicon glyphicon-chevron-left\"><span/>"
        }
      }
};

$.atsjs.prototype._indexOfArrayObject = function(array, key, value){
  for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
          return i;
      }
  }
  return -1;
};

$.atsjs.prototype._isfirefox = function(){
   return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

$.atsjs.prototype._empty = function(value){
	retorno = true;

	if(typeof(value) === undefined){
		retorno = true;
	}else{
		switch(typeof(value)) {
	    case 'string':
	    	retorno = $.trim(value) === '';
	        break;
	    case 'number':
	        retorno = (value === null) || (isNaN(value)) || (value <= 0.0);
	        break;
	    case 'boolean':
	    	retorno = (value === null) || (!value);
	        break;
	    case 'object':
	    	retorno = (value === null) || (Object.keys(value).length <= 0);
	        break;
	    default:
	        retorno = true;
		}
	}

	return retorno;
};

$.atsjs.prototype._lpad = function(valor, quantidade, caracter){
    var s = valor+"";
    while (s.length < quantidade) s = caracter + s;
    return s;
};

$.atsjs.prototype._isValidTime = function(time){

  var matches = /([01][0-9]|2[0-3]):[0-5][0-9]/.exec(time);

  if (matches == null){
      return false;
  }else{
    return true;
  }
};


$.atsjs.prototype._isValidDate = function(date){

    var matches = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(date);

    if (matches == null){
        return false;
    }

    var d = matches[1];
    var m = matches[2] - 1;
    var y = matches[3];
    var composedDate = new Date(y, m, d);

    return composedDate.getDate() == d &&
           composedDate.getMonth() == m &&
           composedDate.getFullYear() == y;
};

$.atsjs.prototype._verificaCpfCnpj = function(valor){
    valor = valor.toString();
    valor = valor.replace(/[^0-9]/g, '');

    if ( valor.length === 11 ) {
        return 'CPF';
    }else if ( valor.length === 14 ) {
        return 'CNPJ';
    }else {
        return false;
    }
};

$.atsjs.prototype._calculaDigitosPosicoes = function(digitos, posicoes, soma_digitos) {
    digitos = digitos.toString();

    for ( var i = 0; i < digitos.length; i++  ) {
        soma_digitos = soma_digitos + ( digitos[i] * posicoes );
        posicoes--;

        if ( posicoes < 2 ) {
            posicoes = 9;
        }
    }

    soma_digitos = soma_digitos % 11;

    if ( soma_digitos < 2 ) {
        soma_digitos = 0;
    } else {
        soma_digitos = 11 - soma_digitos;
    }

    var cpf = digitos + soma_digitos;

    return cpf;
};

$.atsjs.prototype._replaceAll = function(str, de, para) {
    var pos = str.indexOf(de);
    while (pos > -1){
		str = str.replace(de, para);
		pos = str.indexOf(de);
	}
    return (str);
};

$.atsjs.prototype._stringToFloat = function(value) {
    if($.trim(value) === ""){
        value =  0;
    }else{
        value = $.atsjs.prototype._replaceAll(typeof(value) === 'number' ? valor.toString() : value, ".","");
        value = $.atsjs.prototype._replaceAll(typeof(value) === 'number' ? valor.toString() : value, ",",".");
        value = parseFloat(value);
    }

    return value;
};

$.atsjs.prototype._somenteNumero = function(e) {
	var keyCode = e.which;
	var ShiftPress = e.shiftKey;
	var CtrlPress  = e.ctrlKey;
	var type = e.handleObj.origType;

	 if((!ShiftPress) && (type == "keypress")){

		 if($.atsjs.prototype._isfirefox()){
			 keyCodesDownPermitidos = new Array(8,9,13,37,39,46);
		 }else{
			 keyCodesDownPermitidos = new Array();
			 keyCodesDownPermitidos.push(13);
		 }

		 keyCodesPermitidos = new Array();

	    //numeros e 0 a 9 do teclado alfanumerico
	    for(x=48;x<=57;x++){
	        keyCodesPermitidos.push(x);
	    }

	    //Verifica se a tecla digitada é permitida
	    if (((!ShiftPress) && (!CtrlPress) && ($.inArray(e.keyCode,keyCodesDownPermitidos) != -1)) || ($.inArray(keyCode,keyCodesPermitidos) != -1)){
	    	return true;
	    }else{
	    	return false;
	    }
	}else{
		if($.atsjs.prototype._isfirefox()){
			if((ShiftPress) && (e.keyCode == 9)){
				return true;
			}else{
				return false;
			}
		}else{
			return false;
		}
	}
};

$.atsjs.prototype._validaTelefone = function(value) {

    if($.atsjs.prototype._empty(value)){
        return true;
    }

    value = String(value).replace(/[^0-9]/g, '');

    if((value.length == 10) || (value.length == 11)){
        return true;
    }else{
        return false;
    }
};

$.atsjs.prototype._validaCpf = function(valor) {
    valor = valor.toString();
    valor = valor.replace(/[^0-9]/g, '');
    var array = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444',
                 '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];

    if(array.indexOf(valor) > -1){
        return false;
    }

    var digitos = valor.substr(0, 9);
    var novo_cpf = $.atsjs.prototype._calculaDigitosPosicoes(digitos,10, 0);
    var novo_cpf = $.atsjs.prototype._calculaDigitosPosicoes(novo_cpf, 11, 0);

    if ( novo_cpf === valor ) {
        return true;
    } else {
        return false;
    }
};

$.atsjs.prototype._validaCnpj = function(valor) {
    valor = valor.toString();
    valor = valor.replace(/[^0-9]/g, '');
    var cnpj_original = valor;
    var primeiros_numeros_cnpj = valor.substr( 0, 12 );
    var primeiro_calculo = $.atsjs.prototype._calculaDigitosPosicoes(primeiros_numeros_cnpj, 5, 0);
    var segundo_calculo = $.atsjs.prototype._calculaDigitosPosicoes(primeiro_calculo, 6, 0);
    var cnpj = segundo_calculo;

    var array = ['00000000000000'];

    if(array.indexOf(valor) > -1){
        return false;
    }

    if ($.trim(cnpj) == $.trim(cnpj_original)) {
        return true;
    }
    return false;
};

$.atsjs.prototype._validaCpfCnpj = function (valor) {
    var valida = this.verificaCpfCnpj(valor);
    valor = valor.toString();
    valor = valor.replace(/[^0-9]/g, '');

    if ( valida === 'CPF' ) {
        return valida_cpf( valor );
    }else if ( valida === 'CNPJ' ) {
        return valida_cnpj( valor );
    }else {
        return false;
    }
};

$.atsjs.prototype._number_format = function(number, decimals){

    dec_point = ',';
    thousands_sep = '.';

    number = (number + '');
    number = number.replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
      s = '',
      toFixedFix = function(n, prec) {
        var k = Math.pow(10, prec);
        return '' + (Math.round(n * k) / k)
          .toFixed(prec);
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
      .split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '')
      .length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1)
        .join('0');
    }
    return s.join(dec);
  };

  $.atsjs.prototype._datatablesAjaxError = function datatableAjaxError( xhr, textStatus, error, table, toasterUtil) {

    let resp = xhr.responseJSON.error_description;

    if (textStatus === 'timeout') {
		  toasterUtil.erro('O servidor levou muito tempo para enviar os dados.');
    }else if (resp.substring(0,20).toLowerCase() == "access token expired") {
      toasterUtil.erro('Sessão expirada.');
      window.location.href = '/';
    }else {
		  toasterUtil.erro(error);
	  }
	  if(table != null){
        if(typeof table.fnProcessingIndicator == 'function'){
            table.fnProcessingIndicator(false);
        }
	  }
};

$.atsjs.prototype._datatablesServerData = function (sSource, aoData, fnCallback, table, authorization, toasterUtil) {
	(table == undefined) && (table = null);
	$.ajax({
		dataType: 'json',
		type: 'POST',
		url: sSource,
		data: aoData,
		success: fnCallback,
		timeout: 10000,
		beforeSend: function (xhr) {
			xhr.setRequestHeader ("Authorization", "Bearer " + authorization);
		},
		error: function ( xhr, textStatus, error){
			$.atsjs.prototype._datatablesAjaxError(xhr, textStatus, error, table, toasterUtil);
		}
	});
};

$.atsjs.prototype._datatablesServerDataGET = function (sSource, fnCallback, table, authorization, toasterUtil) {
	(table == undefined) && (table = null);
	$.ajax({
		dataType: 'json',
		type: 'GET',
		url: sSource,
		data: '',
		success: function(d) {
            console.log(d);
            const data = {
                aaData: d,
                iTotalRecords: d.length,
                iTotalDisplayRecords: d.length,
                sSearch: "",
                sEcho: "1"
            };
            fnCallback(data);
        },
		timeout: 10000,
		beforeSend: function (xhr) {
			xhr.setRequestHeader ("Authorization", "Bearer " + authorization);
		},
		error: function ( xhr, textStatus, error){
			$.atsjs.prototype._datatablesAjaxError(xhr, textStatus, error, table, toasterUtil);
		}
	});
};

$.ats = new $.atsjs();



// WEBPACK FOOTER //
// src/app/core/ats/script-ats.js